import { render, staticRenderFns } from "./LoyaltyProgramList.vue?vue&type=template&id=e438d97c&scoped=true"
import script from "./LoyaltyProgramList.vue?vue&type=script&lang=js"
export * from "./LoyaltyProgramList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e438d97c",
  null
  
)

export default component.exports